/* istanbul ignore file */
export default ({ palette }) => ({
  offBackground: palette.colors.silver,
  onBackground: palette.colors.lochmara,
  disabledBackground: palette.colors.gallery
});
